<template>
  <div>
    <div class="web-only landing">
      <!-- <div class="web-only" style="padding-top: 17.5vh; padding-bottom: 12vh; padding-left: 8%; padding-right: 8%; width: 100%;">
        <div class="center">
          <h1 style="font-weight: 900; margin-bottom: 18px;">Stop wasting time</h1>
          <h4 style="font-weight: 300; margin-bottom: 35px; max-width: 700px; margin-left: auto; margin-right: auto;">Run your agency smarter with the all-in-one software solution customized just for you. Your clients and candidates will love it.</h4>
          <iframe style="margin-bottom: 20px;" width="660" height="325" src="https://www.youtube.com/embed/cOBFDBlW-L4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div> -->

      <div
        v-if="$router.history.current.path != '/nanny-agency-software' && $router.history.current.path != '/nanny-agency-management-software'"
        class="row web-only"
        style="
          color: white;
          padding-top: 60px;
          padding-bottom: 110px;
          padding-left: 7%;
          padding-right: 7%;
          width: 100%;
        "
      >
        <div class="col-lg-6 col-md-7 my-auto">
          <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
          <h1 style="font-weight: 900; margin-bottom: 12px">
            Stop wasting time
          </h1>
          <!-- <div class="web-only">
            <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
          </div> -->
          <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
          <h2 style="
              font-size: 1.75rem;
              line-height: 1.35;
              margin-top: 25px;
              margin-bottom: 2px;
              max-width: 575px;
            ">
            Run your agency with the all-in-one software solution
            customized just for you. Your clients and candidates will love it!
          </h2>
          <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
          <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->

          <!-- <div class="mt-5">
            <router-link
              :to="{ name: 'Book Demo' }"
              class="mylisting-button light-button"
            >Find Childcare</router-link>
            <router-link
              :to="{ name: 'Book Demo' }"
              class="mylisting-button light-button"
            >Provide Childcare</router-link>
          </div> -->
        </div>
        <div
          class="col-lg-6 col-md-5 my-auto web-only px-4"
          style="border-radius: 5%"
        >
          <iframe
            width="600"
            height="335"
            src="https://www.youtube.com/embed/oBx57wXmJp4"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            style="border-radius: 0.5%"
          ></iframe>

          <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/oBx57wXmJp4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> -->
        </div>
      </div>

      <div
        v-if="$router.history.current.path == '/nanny-agency-software' || $router.history.current.path == '/nanny-agency-management-software'"
        class="row web-only"
        style="
          color: white;
          padding-top: 60px;
          padding-bottom: 110px;
          padding-left: 7%;
          padding-right: 7%;
          width: 100%;
        "
      >
        <div class="col-lg-6 col-md-7 my-auto">
          <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
          <h1 style="font-weight: 900; margin-bottom: 12px">
            Stop wasting time
          </h1>
          <!-- <div class="web-only">
            <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
          </div> -->
          <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
          <h2 style="
              font-size: 1.75rem;
              line-height: 1.35;
              margin-top: 25px;
              margin-bottom: 2px;
              max-width: 575px;
            ">
            Run your nanny agency with the all-in-one software solution
            customized just for you. Your caregivers and families will love it!
          </h2>
          <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
          <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->

          <!-- <div class="mt-5">
            <router-link
              :to="{ name: 'Book Demo' }"
              class="mylisting-button light-button"
            >Find Childcare</router-link>
            <router-link
              :to="{ name: 'Book Demo' }"
              class="mylisting-button light-button"
            >Provide Childcare</router-link>
          </div> -->
        </div>
        <div
          class="col-lg-6 col-md-5 my-auto web-only px-4"
          style="border-radius: 5%"
        >
          <iframe
            width="600"
            height="335"
            src="https://www.youtube.com/embed/cOBFDBlW-L4"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            style="border-radius: 0.5%"
          ></iframe>

          <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/oBx57wXmJp4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> -->
        </div>
      </div>
    </div>

    <div class="mobile-only mobile-landing">
      <div
        class=""
        style="
          color: white;
          padding-top: 4vh;
          padding-bottom: 45px;
          padding-left: 2%;
          padding-right: 2%;
          width: 100%;
          margin-top: 0;
        "
      >
        <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
        <h1
          style="font-weight: 900; margin-bottom: 15px"
          class="center"
        >
          Stop wasting time
        </h1>
        <div class="">
          <h4
            style="margin-bottom: 10px; line-height: 1.3"
            class="center"
          >
            Run your agency with the <br>all-in-one software solution customized just for
            you. Your clients & candidates will love it!
          </h4>
          <!-- <h3>solo and small staffing operations.</h3> -->
        </div>
        <div
          class="center"
          style="padding-top: 25px; padding-bottom: 5px"
        >
          <iframe
            width="100%"
            height="180px"
            src="https://www.youtube.com/embed/oBx57wXmJp4"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <!-- <p style="margin-bottom: 2px;" class="center">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
        <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
        <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
      </div>
    </div>

    <div
      class="web-only"
      style="padding-left: 7%; padding-right: 7%"
    >
      <div
        class="mb-5 big-carousel"
        style="margin-top: 75px"
      >
        <CarouselComponent
          :listItems="listTestimonial"
          :itemPerPage="3"
        />
      </div>
      <div
        class="mb-5 medium-carousel"
        style="margin-top: 75px"
      >
        <CarouselComponent
          :listItems="listTestimonial"
          :itemPerPage="2"
        />
      </div>
    </div>

    <div class="center web-only">
      <a
            href="https://www.google.com/search?authuser=1&q=Enginehire&stick=H4sIAAAAAAAAAONgU1IxqDAxTUxMTjaySDNMMTEzSTO1MqgwMzZKTjEwS0tJBTLSTBexcrnmpWfmpWZkFqUCAOL_WSk1AAAA&mat=CWuSl5VloDTK&ved=2ahUKEwjX45yUmqiAAxW_mYkEHQPkAuUQrMcEegQIDRAH#lrd=0x45aacc28f1d464f5:0x632cd06fde32cf5,1,,,,"
            target="_blank"
          >
            <img
              src="../assets/img/home/landing/googlereviews2.jpg"
              alt=""
              class="association-logo mx-3"
            >
          </a>
          <a
            href="https://www.g2.com/products/enginehire/reviews"
            target="_blank"
          >
            <img
              src="../assets/img/home/landing/G2reviews.png"
              alt=""
              class="association-logo mx-3"
            >
          </a>
    </div>

    <div
      class="web-only"
      style="padding-left: 7%; padding-right: 7%"
    >
      <em
        style="margin-top: 70px"
        class="center mb-4"
      >Trusted by hundreds of staffing agencies around the world, including an agency near you!</em>
      <div
        class="row"
        style="max-width: 940px; margin-left: auto; margin-right: auto"
      >
        <div
          class="col customer-logo-container"
          v-for="(agency, index) of listAgencies"
          :key="'agency-' + index"
        >
          <a
            :href="agency.url"
            target="_blank"
          >
            <img
              :src="require(`../assets/img/home/customer_logos/${agency.logo}`)"
              width=""
              height=""
              :alt="agency.alt"
              class="customer-logo"
            />
          </a>
        </div>
      </div>
    </div>

    <div
      class="mobile-only"
      style="
        padding-top: 30px;
        padding-bottom: 50px;
        padding-left: 2%;
        padding-right: 2%;
      "
    >
      <div class="small-carousel">
        <CarouselComponent
          :listItems="listTestimonial"
          :itemPerPage="1"
        />
      </div>
      <div class="tiny-carousel">
        <CarouselComponent
          :listItems="listTestimonial"
          :itemPerPage="1"
          :navigationEnabled="false"
        />
      </div>

      <div class="center pt-4">
      <a
            href="https://www.google.com/search?authuser=1&q=Enginehire&stick=H4sIAAAAAAAAAONgU1IxqDAxTUxMTjaySDNMMTEzSTO1MqgwMzZKTjEwS0tJBTLSTBexcrnmpWfmpWZkFqUCAOL_WSk1AAAA&mat=CWuSl5VloDTK&ved=2ahUKEwjX45yUmqiAAxW_mYkEHQPkAuUQrMcEegQIDRAH#lrd=0x45aacc28f1d464f5:0x632cd06fde32cf5,1,,,,"
            target="_blank"
          >
            <img
              src="../assets/img/home/landing/googlereviews2.jpg"
              alt=""
              class="association-logo mx-1"
            >
          </a>
          <a
            href="https://www.g2.com/products/enginehire/reviews"
            target="_blank"
          >
            <img
              src="../assets/img/home/landing/G2reviews.png"
              alt=""
              class="association-logo mx-1"
            >
          </a>
    </div>

      <div class="">
        <p
          class="center"
          style="font-size: 1rem; padding-top: 35px; padding-bottom: 10px"
        >
          <em>Trusted by an agency near you</em>
        </p>
        <transition
          name="logo"
          mode="out-in"
        >
          <template v-for="(agency, index) of listAgencies">
            <div
              :key="'agency-mobile-' + index"
              class="customer-logo-container"
              v-if="logoCount === index + 1"
            >
              <a
                :href="agency.url"
                target="_blank"
              >
                <img
                  :src="
                    require(`../assets/img/home/customer_logos/${agency.logo}`)
                  "
                  width=""
                  height=""
                  :alt="agency.alt"
                  class="customer-logo"
                />
              </a>
            </div>
          </template>
        </transition>
      </div>
    </div>

    <div
      class="web-only center px-2"
      style="
        background-color: var(--coredarkcolor);
        margin-top: 100px;
        margin-bottom: 120px;
        padding-top: 60px;
        padding-bottom: 70px;
      "
    >
      <h5 style="color: white; margin-bottom: 40px">
        <em>Discover how Enginehire can work for your agency</em>
      </h5>
      <div class="mt-3">
        <router-link
          :to="{ name: 'Demo Video' }"
          class="mylisting-button light-button mx-1"
          target="_blank"
        >Watch the 3 Minute Demo</router-link>
        <router-link
          :to="{ name: 'Book Demo' }"
          class="mylisting-button light-button mx-1"
        >Book a Personal Demo</router-link>
      </div>
      <h5 style="color: white; margin-top: 44px">
        <em>Are you a new agency? Ask about our startup pricing!</em>
      </h5>
    </div>

    <div
      class="mobile-only center px-2"
      style="
        background-color: var(--coredarkcolor);
        margin-top: 20px;
        margin-bottom: 100px;
        padding-top: 60px;
        padding-bottom: 70px;
      "
    >
      <h5 style="color: white; margin-bottom: 39px; line-height: 1.4;">
        <em>Discover how Enginehire can <br>work for your agency</em>
      </h5>
      <div class="mt-3">
        <router-link
          :to="{ name: 'Demo Video' }"
          class="mylisting-button light-button"
        >Watch the 3 Minute Demo</router-link>
      </div>
      <div class="" style="margin-top: 40px;">
        <router-link
          :to="{ name: 'Book Demo' }"
          class="mylisting-button light-button"
        >Book a Personal Demo</router-link>
      </div>
      <h5 style="color: white; margin-top: 44px; line-height: 1.4;">
        <em>Are you a new agency? <br>Ask about our startup pricing!</em>
      </h5>
    </div>

    <div
      class="web-only"
      style="padding-left: 7%; padding-right: 7%"
    >
      <div
        class="center mb-5"
        style="margin-top: 70px"
      >
        <h3 style="font-weight: 600; margin-bottom: 10px">
          Spend less time. Make more money!
        </h3>
        <h5 class="" style="margin-bottom: 40px;">
          Stop doing grunt work. Logical agency owners like you using Enginehire...
        </h5>
        <img
          style="max-width: 80%"
          src="../assets/img/home/landing/key-benefits-text.svg"
          alt=""
        />
      </div>
    </div>

    <div
      class="mobile-only"
      style="padding-left: 7%; padding-right: 7%"
    >
      <div
        class="center mb-5"
        style="margin-top: 40px"
      >
        <h3 style="font-weight: 600; margin-bottom: 5px">Spend less time.</h3>
        <h3 style="font-weight: 600; margin-bottom: 10px">Make more money!</h3>
        <h5 class="mb-4">
          Stop doing grunt work. Logical agency owners like you using Enginehire...
        </h5>
        <img
          style="max-width: 100%"
          src="../assets/img/home/landing/key-benefits-mobile-text.svg"
          alt=""
        />
      </div>
    </div>

    <!-- <div
      class="web-only center"
      style="
        background-color: var(--coredarkcolor);
        margin-top: 120px;
        padding-top: 60px;
        padding-bottom: 70px;
      "
    >
      <h5 style="color: white; margin-bottom: 33px;"><em>Do you work with Bright Horizons or Care.com?</em></h5>
      <div class="mt-3">
        <router-link
          :to="{ name: 'Backup Care Assistant' }"
          class="mylisting-button light-button"
          target="_blank"
        >Meet the Backup Care Assistant</router-link>
      </div>
    </div> -->

    <!-- <div
      class="mobile-only center"
      style="
        background-color: var(--coredarkcolor);
        margin-top: 100px;
        padding-top: 60px;
        padding-bottom: 70px;
      "
    >
      <h5 style="color: white; margin-bottom: 33px; line-height: 1.35;"><em>Do you work with <br>Bright Horizons or Care.com?</em></h5>
      <div class="mt-3">
        <router-link
          :to="{ name: 'Backup Care Assistant' }"
          class="mylisting-button light-button"
          target="_blank"
        >Meet the Backup Care Assistant</router-link>
      </div>
    </div> -->

    <div style="padding-left: 7%; padding-right: 7%">
      <div class="features-summary-section">
        <div
          class="card feature-container"
          v-for="(feature, index) of listFeatures"
          :key="'feature-' + index"
        >
          <img
            class="feature-img"
            :src="require(`../assets/img/home/icons/${feature.icon}`)"
            :alt="feature.alt"
          />
          <div class="card-body">
            <h4 class="card-title">{{ feature.title }}</h4>
            <p class="card-text">
              {{ feature.text }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      class="center pt-5 pb-5"
      style="margin-top: 60px; margin-bottom: 120px;"
    >
      <h4 style="color: var(--coredarkcolor);">Want to see these features and functionality in action?</h4>
      <a
        href="https://youtu.be/cOBFDBlW-L4"
        target="_blank"
        style="color: white;;"
      ><button class="mylisting-button dark-button">Watch the 2 Minute Demo</button></a>
    </div> -->

    <!-- <div
      class="web-only"
      style="
        background-color: var(--coredarkcolor);
        padding-top: 45px;
        padding-bottom: 45px;
      "
    >
      <p
        class="center"
        style="color: white"
      >
        <strong>Enginehire Inc. | 1855 755 4473 |
          <a
            href=""
            onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;"
          >Book a Demo</a>
          | info@enginehire.io | Hiring re-engineered.</strong>
      </p>
      <img
        src="../assets/img/logo/enginehire logo thin white 1.3 letterpaths.svg"
        width=""
        height="55"
        alt="Enginehire"
        style=""
        class="center mt-4"
      />
    </div> -->

    <!-- <div
      class="mobile-only"
      style="
        background-color: var(--coredarkcolor);
        padding-top: 35px;
        padding-bottom: 35px;
      "
    >
      <p
        class="center"
        style="color: white; font-size: 0.9rem; padding-top: 1.25vh"
      >
        Enginehire Inc. | 1855 755 4473 |
        <a
          href=""
          onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;"
          >Book a Demo</a
        >
        | info@enginehire.io | Hiring re-engineered.
      </p>
      <img
        src="../assets/img/logo/enginehire logo thin white 1.3 letterpaths.svg"
        width=""
        height="55"
        alt="Enginehire"
        style=""
        class="center mt-4"
      />
    </div> -->

    <div class="web-only mb-5">
      <em
        style=""
        class="center mb-4"
      >We are proud members and sponsors of the</em>
      <div
        class="row"
        style="max-width: 650px; margin-left: auto; margin-right: auto"
      >
        <div class="col association-logo-container">
          <a
            href="https://nanny.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/INA-Logo-2022.png"
              alt="INA International Nanny Association"
              class="association-logo"
            >
          </a>
        </div>
        <div class="col association-logo-container">
          <a
            href="https://www.nannyrelieffund.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/nanny relief fund.png"
              alt="Nanny Relief Fund"
              class="association-logo"
              style="height: 60px; margin-top: 7px;"
            >
          </a>
        </div>
        <div class="col association-logo-container">
          <a
            href="https://theapna.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/APNA wide.png"
              alt="APNA Association of Premier Nanny Agencies"
              class="association-logo"
              style="height: 75px; padding-left: 10px;"
            >
          </a>
        </div>
      </div>
    </div>

    <div class="mobile-only mb-5">
      <em
        style=""
        class="center mb-4"
      >We're proud members & sponsors of the</em>
      <div class="col association-logo-container-mobile">
          <a
            href="https://nanny.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/INA-Logo-2022.png"
              alt="INA International Nanny Association"
              class="association-logo"
              style="height: 50px;"
            >
          </a>
        </div>
        <div class="col association-logo-container-mobile">
          <a
            href="https://www.nannyrelieffund.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/nanny relief fund.png"
              alt="Nanny Relief Fund"
              class="association-logo"
              style="height: 45px; margin-top: 0px;"
            >
          </a>
        </div>
      <div class="col association-logo-container-mobile">
          <a
            href="https://theapna.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/APNA wide.png"
              alt="APNA Association of Premier Nanny Agencies"
              class="association-logo"
              style="height: 55px; padding-left: 0px;"
            >
          </a>
        </div>
        <!-- <div
        class="row"
        style="max-width: 650px; margin-left: auto; margin-right: auto"
      >
        <div class="col association-logo-container">
          <a
            href="https://nanny.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/INA-Logo-2022.png"
              alt=""
              class="association-logo"
              style="height: 40px;"
            >
          </a>
        </div>
        <div class="col association-logo-container">
          <a
            href="https://www.nannyrelieffund.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/nanny relief fund.png"
              alt=""
              class="association-logo"
              style="height: 30px; margin-top: 5px;"
            >
          </a>
        </div>
        <div class="col association-logo-container">
          <a
            href="https://theapna.org/"
            target="_blank"
          >
            <img
              src="../assets/img/associations/APNA wide.png"
              alt=""
              class="association-logo"
              style="height: 40px; padding-left: 10px;"
            >
          </a>
        </div>
      </div> -->
    </div>

    <!-- <div class="web-only">
      <em
        style="margin-top: 90px"
        class="center mb-4"
      >Proud member and sponsor of</em>
      <div
        class="center"
        style=""
      >
        <a
          href="https://nanny.org/"
          target="_blank"
        >
          <img
            src="../assets/img/associations/INA-Logo-2022.png"
            alt=""
            class="association-logo"
          >
        </a>
        <a
          href="https://www.nannyrelieffund.org/"
          target="_blank"
        >
          <img
            src="../assets/img/associations/nanny relief fund.png"
            alt=""
            class="association-logo"
            style="height: 60px; margin-top: 7px; padding-left: 30px; padding-right: 30px;"
          >
        </a>
        <a
          href="https://theapna.org/"
          target="_blank"
        >
          <img
            src="../assets/img/associations/APNA wide.png"
            alt=""
            class="association-logo"
            style="height: 75px;"
          >
        </a>
      </div>
    </div> -->
  </div>
</template>

<script>
import CarouselComponent from "./CarouselComponent";

export default {
  created() {
    // Scroll the window to top on load
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    window.location.replace("https://enginehire.io/");
  },
  components: {
    CarouselComponent,
  },
  // https://stackoverflow.com/questions/49849376/vue-js-triggering-a-method-function-every-x-seconds
  mounted: function () {
    window.setInterval(() => {
      this.incrementLogoCount();
    }, 3000);
  },
  data() {
    return {
      logoCount: 1,
      listTestimonial: [
        {
          text: "<strong>We have used so many platforms.</strong> From iCims to Bullhorn, to trying to create ones ourselves with Zoho, Asana, Monday.com, Trello, and Airtable. <strong>They just did not work for our industry.</strong> Enginhire has created a logical system that is simple to use with lots of amazing features. I am so glad we found them.",
          img: {
            src: "Ruka.png",
            alt: "Ruka Curate Tiny Treasures NYC Staffing Agency",
          },
          personInfo: "Ruka C - Co-Founder of",
          link: {
            text: "Tiny Treasures NYC",
            url: "https://www.tinytreasuresnyc.com/",
          },
        },
        // {
        //   text: "As an agency our previous experiences with other software has been less than ideal, but Enginehire has been an absolute breath of fresh air. They are <strong>loyal, reliable, and extremely quick to respond</strong> when an issue arises. They have consistently strived for the <strong>most innovative and user friendly solutions to optimize our business</strong>.",
        //   img: {
        //     src: "caroline.jpg",
        //     alt: "Caroline",
        //   },
        //   personInfo: "Caroline W - Co-founder of",
        //   link: {
        //     text: "Trusting Connections",
        //     url: "https://www.trustingconnections.com/",
        //   },
        // },
        {
          text: "When I first spoke with Enginehire I thought the price was a little steep and almost did not move forward. Ever since then <strong>the price is worth every penny.</strong> If I ever need anything updated, <strong>they respond almost immediately</strong> with a solution. They are continuously working to keep the system updated and <strong>always adding new features</strong>!",
          img: {
            src: "SarahM.png",
            alt: "Sarah Meadors Nannies Coast to Coast Staffing Agency",
          },
          personInfo: "Sarah M - Founder of",
          link: {
            text: "Nannies Coast to Coast",
            url: "https://nanniescoasttocoast.com/",
          },
        },
        {
          text: "<strong>BEST software you will find in the market for NANNY AGENCIES!</strong> The automation of the system saves so much time and the way <strong>you just need to use one software instead of having 10 software for different things.</strong> Also, they are very accommodating to your needs.",
          img: {
            src: "Alejandra.png",
            alt: "Alejandra La Lune Sitters Agency",
          },
          personInfo: "Alejandra D - Owner of",
          link: {
            text: "La Lune Sitters",
            url: "https://www.lalunesitters.com/",
          },
        },
        {
          text: "The Enginehire team was absolutely <strong>wonderful to work with; professional, dedicated, and supportive</strong>. I cannot recommend Enginehire enough if you're looking for a way to <strong>streamline your processes</strong> and work with a patient and understanding team.",
          img: {
            src: "deniz.jpg",
            alt: "Deniz Hanson Trusted Nanny Match Staffing Agency",
          },
          personInfo: "Deniz H - Founder of",
          link: {
            text: "Trusted Nanny Match",
            url: "https://www.trustednannymatch.com/",
          },
        },
        {
          text: "The Enginehire Team have been excellent to work with and provide <strong>phenomenal customer service</strong>. Their <strong>knowledge of the industry and individual customization is unparalleled</strong> and their platform has revolutionized the way that my team does business.",
          img: {
            src: "lydia.jpg",
            alt: "Lydia Sommet Nannies Staffing Agency",
          },
          personInfo: "Lydia B - Owner of",
          link: {
            text: "Sommet Nannies",
            url: "https://www.sommetnannies.com/",
          },
        },
        {
          text: "I should have done this months ago. <strong>I waited out of fear and concern that automation wouldn't be the right fit for such a personalized service. I was so wrong</strong> and I'm kicking my past self for waiting! Any agency that is on the fence or considering Enginehire should just take the plunge. It is worth every penny!",
          img: {
            src: "ameliaG2.png",
            alt: "Amelia Nannies Agency",
          },
          personInfo: "Amelia D - Owner of",
          link: {
            text: "Amelia's Nannies",
            url: "https://www.ameliasnannies.com/",
          },
        },
        {
          text: "I have used two other management platforms and I can tell you that Enginehire is the best. Want a one-stop shop? You can match people to jobs, build resumes directly from their profiles, and so much more in seconds. <strong>Enginehire has saved me money by saving me time.</strong>",
          img: {
            src: "debra.jpg",
            alt: "Debra Elite Family Care Staffing Agency",
          },
          personInfo: "Debra F - Owner of",
          link: {
            text: "Elite Family Care",
            url: "https://elitefamilycare.com/",
          },
        },
        {
          text: "<strong>I consulted with Enginehire before my agency was even officially launched.</strong> They helped me greatly by providing me with an internal and external-facing system for candidates to apply on my site. Most agency owners I speak with either use Enginehire currently or they are making the switch over to Enginehire from another platform.",
          img: {
            src: "alison_myhouseholdmanaged.png",
            alt: "Alison My Household Managed Staffing Agency",
          },
          personInfo: "Alison G - Owner of",
          link: {
            text: "My Household Managed",
            url: "https://myhouseholdmanaged.com/",
          },
        },
      ],
      listAgencies: [
        {
          url: "https://tlcforkids.com/",
          logo: "tlcsmall.jpg",
          alt: "TLC For Kids Staffing Agency",
        },
        {
          url: "https://www.preferredchildcare.com/",
          logo: "PreferredChildCareLogo.png",
          alt: "Preferred Child Care Staffing Agency",
        },
        {
          url: "https://www.themtotoagency.com/",
          logo: "mtoto.png",
          alt: "The Mtoto Childcare Staffing Agency",
        },
        // {
        //   url: "https://nannyagency.com/",
        //   logo: "PhiladelphiaNannyNetwork.jpg",
        //   alt: "Philadelphia Nanny Network Agency",
        // },
        {
          url: "https://www.grapevineplacementagency.com/",
          logo: "Grapevine Nannies and Domestics full color logo.png",
          alt: "Grapevine Placement Agency",
        },
        {
          url: "https://www.mbfagency.com/",
          logo: "moms-best-friend.jpg",
          alt: "Mom's Best Friend Staffing Agency",
        },
        // {
        //   url: "https://www.mygirlfri.com/",
        //   logo: "MGF-logo-with-text2-300x300.jpg",
        //   alt: "My Girl Friday Staffing Agency",
        // },

        // {
        //   url: "https://trustingconnections.com/",
        //   logo: "trusting_connections-emblem_vector-gold.svg",
        //   alt: "Trusting Connections",
        // },
        {
          url: "https://www.windsorhousenannies.com/",
          logo: "whn.png",
          alt: "Windsor House Nannies Staffing Agency",
        },
        // {
        //   url: "https://www.thewellingtonagency.com/",
        //   logo: "the-wellington-agency-logo.png",
        //   alt: "The Wellington Agency",
        // },
        
        {
          url: "https://unitednanny.org/",
          logo: "United+Nanny+Crest.jpg",
          alt: "United Nanny Agency",
        },
        
        {
          url: "https://www.pbjnanny.com/",
          logo: "pbj.png",
          alt: "PB+J Collective Staffing Agency",
        },
        {
          url: "https://nannybydesign.com/",
          logo: "nannybydesign.png",
          alt: "Nanny By Design Agency",
        },
        
        {
          url: "https://anewenglandnanny.com",
          logo: "A-New-England-Nanny-Logo.png",
          alt: "A New England Nanny",
        },
        {
          url: "https://www.lovingcarehomeservices.com/",
          logo: "LovingCareColor.png",
          alt: "Loving Care Home Services Agency",
        },
        {
          url: "https://myhouseholdmanaged.com/",
          logo: "MHM_Logo_Main_clear.png",
          alt: "My Household Managed Staffing Agency",
        },
        // {
        //   url: "http://littleonesnannyagency.com/",
        //   logo: "littleones.jpg",
        //   alt: "Little Ones Nanny Agency",
        // },
        // {
        //   url: "https://apex-social.org/us",
        //   logo: "logo_apex_basic_V2_600px.jpg",
        //   alt: "Apex Social",
        // },
        // {
        //   url: "https://www.ameliasnannies.com/",
        //   logo: "ameilas-nannies.png",
        //   alt: "Amelia's Nannies",
        // },
        {
          url: "https://washburnagency.com/",
          logo: "washburn-share-logo (1).jpg",
          alt: "The Washburn Agency",
        },
        {
          url: "https://www.lalunesitters.com/",
          logo: "LogoLaLuneSittersvector_whitefill.svg",
          alt: "La Lune Sitters Agency",
        },
        {
          url: "http://www.oliveyounanny.com/",
          logo: "OYN-logo-2016_copy_317757b7-57e2-47bc-8bf0-66ccdab347ee.jpg",
          alt: "Olive You Nanny Agency",
        },
        {
          url: "https://elitefamilycare.com/",
          logo: "elitefamilycare-logo.png",
          alt: "Elite Family Care Staffing Agency",
        },
        // {
        //   url: "https://nanniesofthewoodlands.com/",
        //   logo: "nanniesofthewoodlands_busdir.jpg",
        //   alt: "Nannies of the Woodlands",
        // },
        // {
        //   url: "https://www.manhattannannies.com/",
        //   logo: "manhattan_nannies.jpg",
        //   alt: "Manhattan Nannies",
        // },
        {
          url: "https://www.nashvillenannyagency.com/",
          logo: "NNA.jpg",
          alt: "Nashville Nanny Agency",
        },
        {
          url: "https://mansfielddomestics.com/",
          logo: "Main Logo Green and Yellow.png",
          alt: "Mansfield Domestics Staffing Agency",
        },
        {
          url: "https://www.tinytreasuresnyc.com/",
          logo: "tiny treasureshi res.jpg",
          alt: "Tiny Treasures NYC Staffing Agency",
        },
        {
          url: "https://www.nannyportugal.com/",
          logo: "Nanny Portugal Agency Logo Blue.png",
          alt: "Nanny Portugal Staffing Agency",
        },
        {
          url: "https://www.sommetnannies.com/",
          logo: "SOMMET_PRIMARY_CHARCOAL.png",
          alt: "Sommet Nannies Staffing Agency",
        },
        {
          url: "https://www.trustednannymatch.com/",
          logo: "TNM-Monogram-DarkNavy.svg",
          alt: "Trusted Nanny Match Staffing Agency",
        },
        {
          url: "https://pinknannies.com/",
          logo: "PinkNannies-Circle.svg",
          alt: "Pink Nannies Staffing Agency",
        },
        {
          url: "http://minannyauthority.com/",
          logo: "logo-minanny.png",
          alt: "Michigan Nanny Authority Agency",
        },
        {
          url: "https://thenannyhub.com/",
          logo: "thenannyhub.png",
          alt: "The Nanny Hub Staffing Agency",
        },
        {
          url: "https://makingmemoriesagency.com/",
          logo: "making-memories.jpg",
          alt: "Making Memories Agency",
        },
        
        {
          url: "https://familyfirsthsa.com/",
          logo: "familyfirst.png",
          alt: "Family First Staffing Agency",
        },

        // Removed this row of logos
        // {
        //   url: "https://www.helloclementines.com/",
        //   logo: "hello-clementines.png",
        //   alt: "Hello Clementines",
        // },
        // {
        //   url: "https://www.406nannies.com/",
        //   logo: "406Nannies-FullColor-2.png",
        //   alt: "406 Nannies",
        // },
        // {
        //   url: "https://www.jacksonholenannies.com/",
        //   logo: "jhn-logo-horizontal-1.png",
        //   alt: "Jackson Hole Nannies",
        // },
        // {
        //   url: "https://extra-arms.com/",
        //   logo: "extra-arms.png",
        //   alt: "Extra Arms",
        // },

        {
          url: "https://mollycoddlers.net/",
          logo: "mollycoddlers.png",
          alt: "Mollycoddlers Childcare Staffing Agency",
        },
        {
          url: "https://www.atxnannynetwork.com/",
          logo: "austin_nanny_network.png",
          alt: "Austin Nanny Network Agency",
        },
        {
          url: "https://www.portlandnanny.com/",
          logo: "portland-nanny-logo.png",
          alt: "Portland Nanny Agency",
        },
        // {
        //   url: "https://www.mannyandme.com/",
        //   logo: "mannyandme.png",
        //   alt: "Manny & Me",
        // },
        {
          url: "https://www.ateasefamilysolutions.com/",
          logo: "at-ease_new-logo_300ppi-PNG.png",
          alt: "At Ease Family Solutions",
        },
      ],
      listFeatures: [
        {
          icon: "userprofiles3.1.svg",
          title: "Candidate Profiles",
          text: "Modern digital showcases - no more writing and reformatting resumes",
          alt: "Nanny Agency App"
        },
        {
          icon: "beautifulwebsite.svg",
          title: "Client Dashboards",
          text: "Empower your clients, make it easy for them to do what you need them to",
          alt: "Nanny Staffing Agency Website"
        },
        {
          icon: "briefcase.svg",
          title: "Beautiful Job Postings",
          text: "Seamlessly collect applications and attract the best candidates",
          alt: "Nanny Staffing Agency Job Board"
        },
        {
          icon: "phonetracking.svg",
          title: "Shift Management",
          text: "Manage schedules and fill short term placements in seconds",
          alt: "Pro Sitter App"
        },
        {
          icon: "SMS.svg",
          title: "Auto Email+SMS",
          text: "Spend time actually talking to people - no more rewriting the same thing",
          alt: "Staffing Agency Text Messaging"
        },
        {
          icon: "calendar.svg",
          title: "Scheduling",
          text: "Integrated scheduling, no more back and forth “when are you free?” emails",
          alt: "Staffing Agency Meeting Scheduling"
        },
        {
          icon: "creditcards.svg",
          title: "Payments",
          text: "Built in payment processing - no more chasing clients to pay invoices",
          alt: "Stripe Quickbooks Payment Processing"
        },
        {
          icon: "blogwriting.svg",
          title: "Notes",
          text: "Interviews, consultations, reference checks - all your notes, all in one place",
          alt: "Staffing Agency Reference Checking"
        },
        {
          icon: "document.svg",
          title: "Documents",
          text: "Built in documents and e-signatures - no need for PDFs or DocuSign",
          alt: ""
        },
        {
          icon: "analytics.svg",
          title: "Analytics",
          text: "Understand what’s working, what’s not, and how to grow your business further",
          alt: "Staffing Agency Analytics"
        },
      ],
    };
  },
  methods: {
    incrementLogoCount() {
      if (this.logoCount == this.listAgencies.length) {
        this.logoCount = 1;
      } else {
        this.logoCount += 1;
      }
    },
  },
};
</script>

<style>
.landing {
  /* height: 100vh; */
  /* background-color: var(--skyblue); */
  background-color: var(--coredarkcolor);
  /* background-color: #fcbf67; */
  width: 100%;

  /* height: 75vh; */
  /* height: 70vh; */
  /* min-height: 550px; */
  /* padding-left: 5%; */
  /* padding-right: 5%; */

  /* background-color: white;
  background: url("../assets/img/home/landing/AdobeStock_161673435_shaded6.1_compressed.png")
    left center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat; */

  /* background-position: left top; */
}

.momimage {
  /* height: 100vh; */
  /* background-color: var(--skyblue); */
  background-color: var(--coredarkcolor);
  /* background-color: #fcbf67; */
  width: 100%;

  /* height: 75vh; */
  /* height: 70vh; */
  min-height: 550px;
  /* padding-left: 5%; */
  /* padding-right: 5%; */

  background-color: white;
  background: url("../assets/img/home/landing/AdobeStock_392855683.jpg") left
    center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
}

.seniorimage {
  /* height: 100vh; */
  /* background-color: var(--skyblue); */
  background-color: var(--coredarkcolor);
  /* background-color: #fcbf67; */
  width: 100%;

  /* height: 75vh; */
  /* height: 70vh; */
  min-height: 550px;
  /* padding-left: 5%; */
  /* padding-right: 5%; */

  background-color: white;
  background: url("../assets/img/home/landing/AdobeStock_423398211.jpg") left
    center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
}

.mobile-landing {
  /* height: 100vh; */
  background-color: var(--shopify);
  background-color: #fcbf67;
  width: 100%;

  /* height: 75vh; */
  /* height: 70vh;  */
  /* min-height: 550px; */
  padding-left: 5%;
  padding-right: 5%;

  background-color: var(--coredarkcolor);
  /* background-image: url('https://thewallpaper.co//wp-content/uploads/2016/10preview/goku-universal-hero-backgrounds-photo-hd-wallpapers-4k-amazing-desktop-wallpapers-mac-desktop-images-widescreen-1080p-digital-photos-1920x1080.jpg'); */
  /* background-image: url('../assets/img/AdobeStock_272829109_Preview2.png'); */
  /* background-image: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg'); */
  /* background: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg') left center; */
  /* background: url('../assets/img/landing/AdobeStock_95578556_crop1.jpeg') left center; */
  /* background: url('../assets/img/landing/employer/AdobeStock_95578556_crop1_resize1.jpeg') left center; */
  
  /* background: url("../assets/img/home/landing/AdobeStock_161673435_shaded6.1_compressed.png")
    center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat; */

  /* background-position: left top; */
}

.customer-logo-container {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 7px;
  padding-bottom: 38px;
}
.customer-logo {
  height: 70px;
  /* max-width: 100px; */
}

.association-logo-container {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 7px;
  padding-bottom: 38px;
}
.association-logo-container-mobile {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 7px;
  padding-bottom: 25px;
}
.association-logo {
  height: 75px;
  /* max-width: 100px; */
}

.feature-card {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
  /* max-width: 20%; */
  /* width: 99%; */
  /* border: 1px solid gray; */
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.card {
  padding-top: 30px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
  /* max-width: 20%; */
  /* width: 99%; */
  /* border: 1px solid gray; */
  /* box-shadow: 0 .25rem 0.5rem rgba(0,0,0,.15); */
  text-align: center;
  margin-top: 25px;
  /* margin-left: auto; */
  /* margin-right: auto; */

  border: none;
}
.card-body {
  padding: 0.1rem;
}
.feature-card img {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 170px;
}
.card img {
  /* text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 170px; */
}
.card-img-top {
  /* text-align: center; */
  display: block;
  margin-left: 0 !important;
  margin-right: auto !important;
  text-align: left;
  float: left;
  height: 70px;
  margin-bottom: 10px;
}
.feature-img {
  height: 70px;
  display: block;
  margin-right: auto;
  margin-bottom: 10px;
}
.feature-card-title {
  margin-top: 15px;
}
.card-title {
  line-height: 1.3;
  text-align: left;
}
.card-text {
  text-align: left;
}

.testimonial-card {
  /* background-color: #eaf4fe; */
}
.testimonial-card img {
  /* height: 150px;
  width: 150px;
  border-radius: 50%; */
}

.customer-image {
  border-radius: 50%;
  width: 150px;
}

.visit-platform-button {
  margin-top: 33px;
  margin-bottom: 12px;
}

.logo-enter {
  opacity: 0;
}
.logo-enter-active {
  transition: opacity 1s;
}
.logo-leave {
}
.logo-leave-active {
  transition: opacity 1s;
  opacity: 0;
}

/* ------------------- SMALL -------------------- */
@media (max-width: 768px) {
  .card {
    /* margin-top: 20px; */
    margin-top: 2px;
  }
  .card-deck .card {
    margin-bottom: 2px;
  }
}

.card-image-container {
  text-align: center;
  margin: 1rem 0;
}

.card-image {
  border-radius: 50%;
  text-align: left;
}

.medium-carousel {
  display: none;
}
.big-carousel {
  display: inherit;
}

.small-carousel {
  display: inherit;
  margin: 0 40px;
}
.tiny-carousel {
  display: none;
}

.features-summary-section {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 120px;
}

.feature-container {
  flex-basis: 20%;
  padding-left: 30px;
  padding-right: 30px;
}

@media (max-width: 1280px) {
  .medium-carousel {
    display: inherit;
  }
  .big-carousel {
    display: none;
  }
  .feature-container {
    flex-basis: 25%;
  }
}

@media (max-width: 960px) {
  .feature-container {
    flex-basis: 33.33%;
  }
}

@media (max-width: 768px) {
  .features-summary-section {
    margin-bottom: 100px;
  }
  .feature-container {
    flex-basis: 50%;
  }
}

@media (max-width: 575px) {
  .feature-container {
    flex-basis: 100%;
  }
}

@media (max-width: 460px) {
  .small-carousel {
    display: none;
  }
  .tiny-carousel {
    display: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home2.vue